import {getMethod, postMethod, putMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownExcursionServiceCategories', request)
}

async function post(request) {
    return await postMethod('/api/ownExcursionServiceCategories', request)
}

async function put(request) {
    return await putMethod('/api/ownExcursionServiceCategories', request)
}

export {get, post, put}
